import React, { useRef, useState } from 'react'
import {
  Button,
  DialogContent,
  Grid,
  IconButton,
  InputLabel,
  Typography
} from '@material-ui/core'
import DialogAster from 'asterX-UIkit/Dialog/DialogAster'
import DialogTitleCustom from 'asterX-UIkit/Dialog/DialogTitleCustom'

import { MiscService } from 'lib/api'
import AsterTextField from 'asterX-UIkit/Inputs/AsterTextField'

import { useResErrors } from 'hooks'
import { useSnackbar } from 'notistack'
import { ThumbDown, ThumbUp } from '@material-ui/icons'
import { useReviewStyles } from './review.styles'

const answers = [
  {
    title: 'Вашу проблему решили?'
  },
  {
    title: 'Удовлетворены ли вы скоростью решения проблемы?'
  },
  {
    title: 'Удовлетворены ли вы вежливостью специалистов поддержки?'
  }
]

const ReviewModal = ({ requestList, open, onClose }) => {
  const classes = useReviewStyles()
  const { standardCheck } = useResErrors()
  const { enqueueSnackbar } = useSnackbar()
  const modalRef = useRef(null)

  const [selectedOptions, setSelectedOptions] = useState([])
  const [comment, setComment] = useState('')

  const handleClose = () => {
    onClose()
  }
  const handleOptionClick = (index, option) => {
    const updatedOptions = [...selectedOptions]
    updatedOptions[index] = option
    setSelectedOptions(updatedOptions)
  }

  const handleChange = event => {
    const { value } = event.target
    setComment(value)
  }

  const handleSave = async () => {
    if (selectedOptions?.length !== 3 || selectedOptions.includes(undefined)) {
      enqueueSnackbar('Необходимо заполнить весь опросник!', {
        variant: 'error'
      })
      return
    }

    const data = {
      supportOfficer: requestList?.adminUsername,
      supportId: requestList?.id,
      department: requestList?.department,
      module: requestList?.module,
      problemSolved: selectedOptions[0],
      solveSpeed: selectedOptions[1],
      supportOfficerPoliteness: selectedOptions[2],
      comment: comment || undefined
    }

    await MiscService.supportQuestionnaire(data).then(res =>
      standardCheck(res, ({ data }) => {
        enqueueSnackbar('Отправлено', {
          variant: 'success'
        })
        handleClose()
        window.location.reload()
      })
    )
  }

  return (
    <DialogAster id="modal" onClose={handleClose} open={open}>
      <DialogTitleCustom onClose={handleClose}>
        Оставьте отзыв
      </DialogTitleCustom>
      <DialogContent ref={modalRef}>
        <Grid item container spacing={2}>
          {answers.map((item, idx) => (
            <Grid item container xs={12} sm={12} md={12} key={`answers_${idx}`}>
              <Grid
                item
                container
                xs={12}
                md={12}
                className={classes.container}
              >
                <Grid item container xs={8} md={8} alignItems="center">
                  <Typography
                    style={{
                      fontSize: 14
                    }}
                  >
                    {item.title}
                  </Typography>
                </Grid>
                <Grid
                  item
                  container
                  xs={4}
                  md={4}
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="center"
                >
                  <IconButton
                    size="small"
                    color={selectedOptions[idx] === true ? 'primary' : 'info'}
                    className={classes.buttonLike}
                    onClick={() => handleOptionClick(idx, true)}
                  >
                    <ThumbUp />
                  </IconButton>
                  <IconButton
                    size="small"
                    color={selectedOptions[idx] === false ? 'primary' : 'info'}
                    className={classes.buttonLike}
                    style={{ marginLeft: 8 }}
                    onClick={() => handleOptionClick(idx, false)}
                  >
                    <ThumbDown />
                  </IconButton>
                </Grid>
              </Grid>
            </Grid>
          ))}

          <Grid item xs={12} md={12}>
            <InputLabel style={{ marginBottom: '3px' }}>
              {'Ваш комментарий'}
            </InputLabel>
            <AsterTextField
              label="Написать..."
              fullWidth
              multiline
              rows={5}
              name={'comment'}
              value={comment}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <Button
              fullWidth
              variant="contained"
              color={'primary'}
              onClick={handleSave}
              style={{ padding: 10 }}
            >
              {'Отправить'}
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </DialogAster>
  )
}
export default ReviewModal
